import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
import { isMobile } from '../helpers/exportFunc';
import classToggle from '../helpers/class-toggle';
import { applyFilter } from './filter-apply';

export default () => {
	const filter = document.querySelector('.js-filter');
	const filterBtns = document.querySelectorAll('.js-filter-btn');
	const closeBtn = document.querySelector('.js-filter-close');
	const filterLabel = document.querySelector('.js-filter-label');
	const filterPopup = document.querySelector('.js-filter-popup');
	const allTabButtons = document.querySelectorAll('.filter-block__btn');
	const tabsWrapper = document.querySelectorAll('.filter__tabs');
	const filterSwitches = document.querySelector('.filter__switches');
	const tabs = document.querySelectorAll('.js-filter-tab');
	const deleteFiltersButton = document.querySelector('.js-clear-btn');
	const allTabFiltersButtons = document.querySelectorAll('.js-filter-item button');
	const collectionBlock = document.querySelector('.products-grid');

	if (filter) {
		filterBtns.forEach(btn => {
			btn.addEventListener('click', () => {

				if (!btn.classList.contains('js-sort-btn')) {
					filterLabel.classList.add('filter__label--active');
				}
				else {
					filterLabel.classList.remove('filter__label--active');

					if (isMobile()) {

						gsap.to(filterSwitches,
							{
								height: '0'
							}
						);

						filter.classList.remove('filter--filters-option-active');
					}
				}

				filterBtns.forEach((btn) => {
					btn.classList.remove('filter__switch--active');
				});
				btn.classList.add('filter__switch--active');
				openFilter();
				openTab(btn);
			});
		});

		allTabButtons.forEach(btn => {
			let sortWrapper = btn.closest('.filter-block--sort');

			btn.addEventListener('click', () => {
				if (sortWrapper) {
					let siblings = sortWrapper.querySelectorAll('.filter-block__btn');
					classToggle(siblings, btn, 'filter-block__btn--active');
				}
				else {
					btn.classList.toggle('filter-block__btn--active');

					const activeFilterButtons = document.querySelectorAll('.filter__tabs .filter-block__btn--active');

					if ([...activeFilterButtons].length <= 1) {
						deleteFiltersButton.classList.remove('filter__clear-btn--visible');
					}
				}
			});
		});

		closeBtn.addEventListener('click', () => {
			closeFilter();
		});

		filterLabel.addEventListener('click', () => {
			filterBtns.forEach((btn) => {
				btn.classList.remove('filter__switch--active');
			});
			tabs.forEach(tab => {
				tab.classList.remove('filter__tab--active');
			});

			// height 1px to fix blur in Safari
			gsap.to(filterPopup,
				{
					height: '1px'
				}
			);

			filterLabel.classList.add('filter__label--active');
			openFilter();

			gsap.to(filterSwitches,
				{
					height: 'auto'
				}
			);

			filter.classList.add('filter--filters-option-active');
		});

		document.addEventListener('click', (e) => {
			if (!e.target.closest('.js-filter') && !e.target.closest('.js-filter-btn')) {
				closeFilter();
			}
		});

		if (!collectionBlock) {
			return;
		}
		
		let lastScrollTop = 0;
		let isScrollingUp = false;
		
		function updateScrollDirection() {
			const sd = window.pageYOffset || document.documentElement.scrollTop;
			isScrollingUp = sd < lastScrollTop;
			lastScrollTop = sd <= 0 ? 0 : sd;
		}
		
		if (isMobile()) {
			window.addEventListener('scroll', updateScrollDirection);
		}
		
		ScrollTrigger.create({
			trigger: collectionBlock,
			start: 'top 100px',
			end: 'bottom top',

			onEnter: (self) => {
				if (isMobile()) {
					if (isScrollingUp) {
						filter.classList.add('filter--lower', 'filter--scrolled');
					}
				} else {
					filter.classList.add('filter--lower', 'filter--scrolled');
				}
			},
			onLeaveBack: (self) => {
				filter.classList.remove('filter--lower', 'filter--scrolled');
			},

			onUpdate: (self) => {
				if (isMobile()) {
					if (isScrollingUp) {
						filter.classList.add('filter--lower', 'filter--scrolled');
					} else {
						filter.classList.remove('filter--lower', 'filter--scrolled');
					}
				} else {
					filter.classList.add('filter--scrolled');
				}
			}
		});

		deleteFiltersButton.addEventListener('click', () => {

			allTabFiltersButtons.forEach(allTabFiltersButton => {

				allTabFiltersButton.classList.remove('filter-block__btn--active');
			});

			const filterCounters = document.querySelectorAll('.js-filter-count');

			filterCounters.forEach(filterCounter => {

				filterCounter.innerText = '';
			});

			applyFilter();

			const activeFilterButtons = document.querySelectorAll('.filter__tabs .filter-block__btn--active');

			if ([...activeFilterButtons].length <= 1) {
				deleteFiltersButton.classList.remove('filter__clear-btn--visible');
			}
		});
	}

	function openFilter() {
		filter.classList.add('filter--opened');
	}

	function closeFilter() {
		filter.classList.remove('filter--opened');
		filterLabel.classList.remove('filter__label--active');

		filterBtns.forEach((btn) => {
			btn.classList.remove('filter__switch--active');
		});

		tabs.forEach(tab => {
			tab.classList.remove('filter__tab--active');
		});

		// height 1px to fix blur in Safari
		gsap.to(filterPopup,
			{
				height: '1px'
			}
		);

		gsap.to(tabsWrapper,
			{
				opacity: 0,
				duration: 0.3
			}
		);

		if (isMobile()) {

			gsap.to(filterSwitches,
				{
					height: '0'
				}
			);

			filter.classList.remove('filter--filters-option-active');

			document.body.classList.remove('no-scroll');
		}
	}

	function calculateFilterHeight() {
		const filterRow = document.querySelector('.filter__row');
		const filterTabs = document.querySelector('.filter__tabs');

		const heightOfFilterParent = filterRow.offsetHeight;
		const heightFromFilterToTopOfPage = filterRow.getBoundingClientRect().top;

		filterTabs.style.maxHeight = `calc(100dvh - ${heightOfFilterParent + heightFromFilterToTopOfPage}px)`;

		document.body.classList.add('no-scroll');
	}

	function openTab(btn) {

		if (isMobile()) {
			calculateFilterHeight();

			setTimeout(calculateFilterHeight, 300);
		}

		gsap.to(filterPopup,
			{
				height: 'auto'
			}
		);

		const btnData = btn.dataset.target;

		gsap.fromTo(tabsWrapper,
			{
				opacity: 0
			},
			{
				delay: 0.3,
				opacity: 1,
				duration: 0.3
			}
		);

		tabs.forEach(tab => {
			tab.classList.remove('filter__tab--active');
		});

		const activeTab = document.querySelector(`.js-filter-tab[data-tab="${btnData}"]`);

		activeTab.classList.add('filter__tab--active');

		const height = activeTab.offsetHeight;

		gsap.to(filterPopup,
			{
				height
			}
		);

		addFilterCounter(activeTab, btn);
	};

	function addFilterCounter(activeTab, btn) {
		const filterButtons = activeTab.querySelectorAll('.filter-block__btn');

		filterButtons.forEach(filterButton => {
			let sortWrapper = filterButton.closest('.filter-block--sort');

			filterButton.addEventListener('click', () => {
				if (!sortWrapper) {
					const activeFilterButtons = activeTab.querySelectorAll('.filter-block__btn--active');
					const filterCounter = btn.querySelector('.js-filter-count');

					if (filterCounter) {
						if (activeFilterButtons.length > 0) {
							filterCounter.innerText = activeFilterButtons.length;
							deleteFiltersButton.classList.add('filter__clear-btn--visible');
						}
						else {
							filterCounter.innerText = '';
						}
					}
				}
			});
		});
	}
}